import type { ReactNode } from 'react';

import type { GetSellerCommunicationEnquiriesClientApiCall } from 'Pages/api/seller-communications/enquiries/client.api';
import type { PatchSellerCommunicationMarkAsContactedClientApiCall } from 'Pages/api/seller-communications/mark-as-contacted/client.api';
import type { SellerCommunicationStatus } from 'Pages/api/seller-communications/types';

export const ModalSteps = {
	EmailEditor: 'EmailEditor',
	EnquirySelection: 'EnquirySelection',
	EnquirySelectionError: 'EnquirySelectionError',
	EnquirySelectionLoading: 'EnquirySelectionLoading',
	MarkAsContactedConfirmation: 'MarkAsContactedConfirmation',
	MarkAsContactedError: 'MarkAsContactedError',
	MarkAsContactedLoading: 'MarkAsContactedLoading',
	NothingToSend: 'NothingToSend',
	ProcessingEmails: 'ProcessingEmails',
	ProcessingEmailsError: 'ProcessingEmailsError',
} as const;

export type ModalStep = (typeof ModalSteps)[keyof typeof ModalSteps];

export interface ModalFlowStoreState {
	currentStep: ModalStep;
}

export interface EnquiriesSearchStoreState {
	filteredSaleIds: Record<string, boolean>;
	keyword: string;
	noResults: boolean;
	search: string;
}

export interface ModalStoreState {
	isOpen: boolean;
}

export interface StatusStoreState {
	enquiryIds: number[];
	statuses: Record<string, SellerCommunicationStatus>;
}

export interface CountStoreState {
	unsentMessagesCount: string;
}

export type EnquiriesMap = Record<
	string,
	Awaited<ReturnType<GetSellerCommunicationEnquiriesClientApiCall>>['items'][number]
>;

export interface EnquiriesStoreState {
	enquiries: Awaited<ReturnType<GetSellerCommunicationEnquiriesClientApiCall>>['items'];
	enquiriesMap: EnquiriesMap;
	hasMoreItems: boolean;
}

export interface EnquiriesSelectStoreState {
	interactedSaleIds: Record<string, boolean>;
	selectedSaleIds: string[];
}

export interface ProcessingEmailsStoreState {
	errorGroups: {
		enquiries: EnquiriesStoreState['enquiries'];
		title: ReactNode;
	}[];
	result: EmailsSendResponse;
}

export interface EmailBodyStoreState {
	body: string;
	bodyError: string | null;
	isBodyEmpty: boolean;
	saveAsDefaultBody: boolean;
	templateId: string;
}

export interface MarkAsContactedStoreState {
	errorGroups: {
		enquiries: EnquiriesStoreState['enquiries'];
		title: ReactNode;
	}[];
	result: Awaited<ReturnType<PatchSellerCommunicationMarkAsContactedClientApiCall>>;
}

export interface SaleStatus {
	saleId: string;
	status: SellerCommunicationStatus;
}

export interface EmailsSendResponse {
	failedToUpdateSales: SaleStatus[];
	updatedSaleIds: string[];
}
